import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { PartnershipRequestAnalysisContent } from "./PartnershipRequestAnalysisContent";
import { PartnershipRequestAnalysisSkeleton } from "./components/PartnershipRequestAnalysisSkeleton";

const PartnershipRequestAnalysis = () => {
	const { id } = useParams<{ id: string }>();

	if (!id) {
		return <div>Erreur : ID manquant dans l'URL</div>;
	}

	return (
		<Suspense fallback={<PartnershipRequestAnalysisSkeleton />}>
			<PartnershipRequestAnalysisContent id={id} />
		</Suspense>
	);
};

export default PartnershipRequestAnalysis;
